import type { DealMineTeam } from '../../types';
import styles from './DealsPage.module.css';

/** Empty-queue "All done" panel, extracted verbatim from DealsPage.tsx
 *  (D4 componentization, zero behavior change). */

export function AllDoneState({
  canUseCrossTeamScope,
  mineTeam,
  onBackToPipeline,
  backLabel = 'Back to Pipeline',
  onShowTeam,
  onShowAll,
}: {
  canUseCrossTeamScope: boolean;
  mineTeam: DealMineTeam;
  onBackToPipeline: () => void;
  backLabel?: string;
  onShowTeam: () => void;
  onShowAll: () => void;
}) {
  return (
    <div className={styles.allDoneState}>
      <div className={styles.allDoneIcon}>✓</div>
      <div className={styles.allDoneTitle}>All Done! :)</div>
      <div className={styles.allDoneText}>
        No pending updates or new deals are visible under your current filters.
      </div>
      <div className={styles.allDoneActions}>
        <button type="button" className={styles.btnPrimary} onClick={onBackToPipeline}>
          {backLabel}
        </button>
        {canUseCrossTeamScope && (
          <>
            {mineTeam !== 'team' && mineTeam !== 'all' && (
              <button type="button" className={styles.btnSecondary} onClick={onShowTeam}>
                Show Team
              </button>
            )}
            {mineTeam !== 'all' && (
              <button type="button" className={styles.btnSecondary} onClick={onShowAll}>
                Show All
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
